import { useRef } from 'react';
import useEnhancedEffect from '../useEnhancedEffect/useEnhancedEffect';
import type { UseIsFirstRender } from './types';

const useIsFirstRender: UseIsFirstRender = () => {
  const isFirstRender = useRef(true);

  useEnhancedEffect(() => {
    isFirstRender.current = false;
  }, []);

  return isFirstRender.current;
};

export default useIsFirstRender;
